import user from "./user";
import blog from "./blog";
import blogEdit from "./blogEdit"

export default {
    user, blog, blogEdit
};
